<ng-container *ngIf="vraag.vraagtype !== vraagtype.Telefoon">
  <ng-container *ngIf="(resultaten$ | async) as resultaten">
    <ng-container *ngIf="verz_er && verz_er.length > 0">
      <div class="ols-title"><app-sharedtekst [key]="'belangrijk'"></app-sharedtekst></div>
      <div *ngIf="verz_er.length == 1" [innerHTML]="verz_er"></div>
      <ul *ngIf="verz_er.length > 1" class="ols-ml">
        <li *ngFor="let regel of verz_er" [innerHTML]="regel"></li>
      </ul>
      <br>
      <div>
        <span [innerHTML]="vraagtitel"></span><span *ngIf="kenmerkenDisplayValue" [innerHTML]="': ' + kenmerkenDisplayValue"></span>
      </div>
    </ng-container>
    <ng-container *ngIf="!verz_er || verz_er.length === 0">
      <div class="ols-title" [innerHTML]="vraagtitel"></div>
      <div *ngIf="kenmerkenDisplayValue" class="ols-kenmerken">
        <ng-container *ngIf="kenmerk_titel">Op de </ng-container>
        <span *ngIf="kenmerk_titel" [innerHTML]="kenmerk_titel | lowercase"></span> 
        <ng-container *ngIf="kenmerkenDisplayValue"> van {{kenmerkenDisplayValue}}</ng-container>
      </div>
    </ng-container>
  </ng-container>

  <div *ngFor='let regel of vraag.vraagregels' [innerHTML]="regel"></div>
  <div class="vraag__actions">
    <div class="buttons-container">
      <a *ngIf="vraag.vraagtype === vraagtype.Versturen" (click)="eindeVerzekeringkiezer()"
        class="button button--schade has-ripple"
        id="ipoclick-btn-{{geefPazaProces()}}-kiezer-start_schademelden">{{vraag.button_text}}</a>
      <a *ngIf="vraag.vraagtype === vraagtype.NaarSchadetail" (click)="naarSchadetail()"
        class="button button--schade has-ripple"
        id="ipoclick-btn-{{geefPazaProces()}}-kiezer-naar_schadetail">{{vraag.button_text}}</a>
    </div>
  </div>

  <ng-container *ngIf="vraag.control === controltype.Succes && vraag.antwoorden?.length > 1">
    <!-- Dit gaat om vraag V420 met woonglashersteller -->
    <app-woonglashersteller [vraag]="vraag" [inSucces]="true"></app-woonglashersteller>
  </ng-container>
</ng-container>

<ng-container *ngIf="vraag.vraagtype === vraagtype.Telefoon">
  <div class="ols-contact-telefoon">
    <div class="ols-contact">
      <div class="icon"></div>
    </div>
    <div>
      <div class="ols-title">{{vraagtitel}}</div><div *ngIf="kenmerkenDisplayValue" [innerHTML]="kenmerkenDisplayValue"></div>
      <div *ngFor='let regel of vraag.vraagregels' [innerHTML]="regel"></div>
    </div>
  </div>
</ng-container>